import NavBar from "./components/navBar"
import Header from "./components/header"
import Footer from "./components/footer"
import Check from "./components/check"

const App =()=>{
    return(
        <>
        <NavBar />
        <Header />
        <Check />
        <Footer />
        </>
    )
}

export default App